<div [formGroup]="form" class="flex flex-col text-sm mx-4 h-full">

  <mat-form-field appearance="outline" class="mt-4" hideRequiredMarker>
    <mat-label>{{'labels.first-name' | translate | titlecase}}</mat-label>
    <input matInput formControlName="firstName" maxlength="30" [readonly]="driver?.IsArchive">
    <mat-error id="firstName-error-required" *ngIf="!driver?.IsArchive && firstNameCtrl?.hasError('required')">
      {{'errors.field-is-required' | translate}}
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="mt-2" hideRequiredMarker>
    <mat-label>{{'labels.last-name' | translate | titlecase}}</mat-label>
    <input matInput formControlName="lastName" maxlength="50" [readonly]="driver?.IsArchive">
    <mat-error id="lastName-error-required" *ngIf="!driver?.IsArchive && lastNameCtrl.hasError('required')">
      {{'errors.field-is-required' | translate}}
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="mt-2" hideRequiredMarker>
    <mat-label>{{'fields-names.landline-phone' | translate}} ({{'labels.optional' | translate}})</mat-label>
    <input matInput formControlName="phone" maxlength="30" [readonly]="driver?.IsArchive">
  </mat-form-field>

  <mat-form-field appearance="outline" class="mt-2" hideRequiredMarker>
    <mat-label>{{'fields-names.mobile-phone' | translate}} ({{'labels.optional' | translate}})</mat-label>
    <input matInput formControlName="mobilePhone" maxlength="30" [readonly]="driver?.IsArchive">
  </mat-form-field>

  <mat-form-field appearance="outline" class="mt-2" hideRequiredMarker>
    <mat-label>{{'fields-names.email' | translate}} ({{'labels.optional' | translate}})</mat-label>
    <input matInput formControlName="email" maxlength="50" [readonly]="driver?.IsArchive">
    <mat-error id="email-error-email" *ngIf="!driver?.IsArchive && emailCtrl.hasError('email')">
      {{'errors.email-format-incorrect' | translate}}
    </mat-error>
  </mat-form-field>

  <!--  <mat-form-field appearance="outline" class="w-full mt-2" hideRequiredMarker>-->
  <!--    <mat-label>Pojazd użytkownika</mat-label>-->
  <!--    <input type="text" matInput formControlName="vehicle" [matAutocomplete]="auto">-->
  <!--    <mat-autocomplete #auto="matAutocomplete">-->
  <!--      <cdk-virtual-scroll-viewport [style]="{height: height}" itemSize="50" minBufferPx="200" maxBufferPx="300">-->
  <!--        <mat-option *cdkVirtualFor="let option of filtered | async" [value]="option.Id" class="tk-height-50">-->
  <!--          {{option.Nm}}-->
  <!--        </mat-option>-->
  <!--      </cdk-virtual-scroll-viewport>-->
  <!--    </mat-autocomplete>-->
  <!--    <mat-error id="database-error-required" *ngIf="vehicleCtrl.hasError('required')">-->
  <!--      Pole jest wymagane-->
  <!--    </mat-error>-->
  <!--  </mat-form-field>-->

  <!--  <mat-slide-toggle formControlName="is4driverEnabled" class="font-semibold mb-4">-->
  <!--    Dostęp do aplikacji 4Driver-->
  <!--  </mat-slide-toggle>-->

  <app-button *ngIf="!driver?.IsArchive" class="mt-2" [isLoading]="isLoadingOrSaving" [isFullWidth]="true"
              [isActive]="form.valid" innerTextClasses="text-sm"
              spinnerClasses="my-1.5" label="{{'labels.save' | translate | titlecase}}" (click)="onSave()"></app-button>

  <div *ngIf="isArchiveDriverVisible" class="grow flex flex-col justify-end">
    <div class="flex justify-center mb-4">
      <sm-secondary-button *ngIf="!driver?.IsArchive"
                           label="{{'worker.move-to-archive' | translate}}"
                           iconClasses="tk-c-red text-xl" textClasses="tk-c-red" icon="archive"
                           [isLoading]="isChangingArchiveStatus" (click)="onChangeIsArchive()"></sm-secondary-button>

      <sm-secondary-button *ngIf="driver?.IsArchive"
                           label="{{'worker.move-from-archive' | translate}}"
                           iconClasses="tk-c-red text-xl" textClasses="tk-c-red" icon="unarchive"
                           [isLoading]="isChangingArchiveStatus" (click)="onChangeIsArchive()"></sm-secondary-button>
    </div>

    <!--    <div class="bg-gray-1 py-3 px-3">-->

    <!--      <div *ngIf="is4DriveAuthorized else notAuthorized" class="flex">-->
    <!--        <div class="rounded-full tk-green-2-bg w-2 h-2 self-center mr-3"></div>-->
    <!--        <span class="tk-c-green-2 font-semibold">Zautoryzowany w 4Driver</span>-->
    <!--      </div>-->

    <!--      <ng-template #notAuthorized>-->
    <!--        <div class="flex">-->
    <!--          <div class="rounded-full bg-red w-2 h-2 self-center mr-3"></div>-->
    <!--          <div class="tk-c-red font-semibold">Niezautoryzowany w 4Driver</div>-->
    <!--        </div>-->
    <!--        <div class="tk-c-gray ml-5">(kod autoryzacji 123456)</div>-->
    <!--      </ng-template>-->

    <!--    </div>-->

    <!--    <div class="flex my-8">-->
    <!--      <div></div>-->
    <!--      <span matTooltip="SMS został wysłany" matTooltipPosition="right" #tooltip="matTooltip" (click)="tooltip.show()"-->
    <!--            class="tk-c-blue cursor-pointer">-->
    <!--        Wyślij dane logowania przez SMS-->
    <!--      </span>-->
    <!--    </div>-->
    <!--    material-symbols-outlined-->

  </div>
</div>
